import * as CarriersConstants from './carriers.constants';

export default CarriersConstants;
